// extracted by mini-css-extract-plugin
module.exports = {"container":"_b0","logo":"_b1","mainPanel":"_b2"};